export enum ROLES {
  ADMIN = 'Admin',
  COMMUNICATOR = 'Communicator',
}

export enum ROLES_ACTIONS {
  UPDATE = 'Update',
  DELETE = 'Delete',
}

export const ADMIN_CONDITIONS = {
  Workspace: 'Write',
  Settings: 'Write',
  Management: 'Write',
};
